import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import colors from "../../../theme/colors";

const Item = styled(Button)(({ theme }) => ({
  backgroundColor: colors.cardBg,
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: colors.primary,
  height: 150,
  display: "inline",
  textTransform: "none",
  width: "100%",
  borderRadius: 20,
  boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  '&:hover': {
    backgroundColor: colors.hover,
    transform: "scale(1.10)",
  },
}));

export default Item;
